export class Constants {

    static ROLE_SUPER_ADMIN: string = "Super Admin";

    public static API_ERROR: string = "Unable to process request, Please try again later";

    public static ERROR: string = "error";
    public static SUCCESS: string = "SUCCESS";
    public static FAILED: string = "FAILED";

    static RELOAD_ON_ROLE_CHANGE: string = "Active role updated, reloading workspace.";
    static RELOAD_ON_FACILITY_CHANGE: string = "Active facility updated, reloading workspace.";
    static USER_DATA_EXPORT: string = "Members data being exported, Please wait.";
    static FILE_UPLOAD_START: string = "File is being uploaded.";
    static FILE_UPLOAD_COMPLETE: string = "File uploaded successfully.";

    static PATIENT_CATEGORY_ADDED: string = "Patient category added successfully.";
    static PATIENT_CATEGORY_UPDATED: string = "Patient category updated successfully."

    static PATIENT_REFERRAL_SOURCE_ADDED: string = "Patient referral source added successfully.";
    static PATIENT_REFERRAL_SOURCE_UPDATED: string = "Patient referral source updated successfully."

    static UNABLE_TO_PROCESS: string = "Unable to process request, please reload.";

    static DEFAULT_MAXLENGTH_VALIDATION_SIZE: number = 100;
    static DEFAULT_ZIPCODE_VALIDATION_SIZE: number = 6;
    static DEFAULT_MOBILE_VALIDATION_SIZE: number = 10;
    static DEFAULT_TEXTAREA_VALIDATION_SIZE: number = 250;
    static DEFAULT_TAXID_VALIDATION_SIZE: number = 10;
    static DEFAULT_TAXONOMY_VALIDATION_SIZE: number = 10;
    static DEFAULT_DOCUMENT_ID_VALIDATION_SIZE: number = 10;

}
